module.exports = __webpack_public_path__ + "media/images/chats/mariam-escape-to-airport-.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/chats/mariam-escape-to-airport-.jpg
// module id = 74
// module chunks = 0